import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/page/login'
import LoginCode from '@/page/logincode'
import ResetGetAccount from '@/page/ResetGetAccount'
import ResetGetCode from '@/page/ResetGetCode'
import ResetSetPwd from '@/page/ResetSetPwd'
import ResetpwdSuccess from '@/page/ResetpwdSuccess'
import LoginSuccess from '@/page/loginSuccess'
import LoginFail from '@/page/LoginFail'
import LogOut from '@/page/LogOut'
import Userinfo from '@/page/userinfo'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'LoginCode',
      component: LoginCode
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/logincode',
      name: 'LoginCode',
      component: LoginCode
    },
    {
      path: '/resetpwd1',
      name: 'ResetGetAccount',
      component: ResetGetAccount
    },
    {
      path: '/resetpwd2',
      name: 'ResetGetCode',
      component: ResetGetCode
    },
    {
      path: '/resetpwd3',
      name: 'ResetSetPwd',
      component: ResetSetPwd
    },
    {
      path: '/resetpwd4',
      name: 'ResetpwdSuccess',
      component: ResetpwdSuccess
    },
    {
      path: '/loginsuccess',
      name: 'LoginSuccess',
      component: LoginSuccess
    },
    {
      path: '/loginfail',
      name: 'LoginFail',
      component: LoginFail
    },
    {
      path: '/logout',
      name: 'LogOut',
      component: LogOut
    },
    {
      path: '/userInfo',
      name: 'Userinfo',
      component: Userinfo
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js